import { helpers } from 'vuelidate/lib/validators'

export const email = helpers.regex('email', /^[a-zA-Z0-9#$%&*/_.-]+[a-zA-Z0-9#$%&*/_-]@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/)
export const zenkakukana = helpers.regex('zenkakukana', /^[\u30A1-\u30ED\u30EF\u30F2-\u30F4\u30FCー－゜゛]+$/)
export const phoneNumber = helpers.regex('phoneNumber', /^[0-9]{10,11}$/)
export const accountNumber = helpers.regex('accountNumber', /^\d{7}$/)
export const okasanAccountNumber = helpers.regex('accountNumber', /^[1-9]{1}[0-9]{3,8}$/)
